export default __webpack_public_path__ + "static/media/Biology_CellMetabolismCycle_2021.8011a3f0.pdf";